module.exports = __webpack_public_path__ + "img/logo2.1681a5f0.png";